module.exports = __webpack_public_path__ + "img/teamwork.c3bc214e.svg";